import { render, staticRenderFns } from "./OrderProjectForm.vue?vue&type=template&id=159b84cc"
import script from "./OrderProjectForm.vue?vue&type=script&lang=js"
export * from "./OrderProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports